var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableHeaderIconCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "14px",
    viewBox: "0 0 22 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-credit-card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage-Credit-Cards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00:-Table-of-Contents",
    transform: "translate(-725.000000, -396.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(698.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-credit-card",
    transform: "translate(38.124344, 67.000000) rotate(-360.000000) translate(-38.124344, -67.000000) translate(28.624344, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 0.616255)",
    stroke: "#A1A5B3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 0.383745)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    x: 0,
    y: 0,
    width: 19,
    height: 12,
    rx: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    fill: "#A1A5B3",
    x: 1,
    y: 4,
    width: 18,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    fill: "#A1A5B3",
    x: 2.65530315,
    y: 8.52268696,
    width: 9,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-24",
    fill: "#A1A5B3",
    x: 13.8793086,
    y: 8.52268696,
    width: 2.65957551,
    height: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHeaderIconCreditCard);
export default __webpack_public_path__ + "static/media/table-header-icon-credit-card.cec5d1771e33981bbfe9afa55d494bcd.svg";
export { ForwardRef as ReactComponent };